import { render, staticRenderFns } from "./BusinessNatrue.vue?vue&type=template&id=92f282e8&scoped=true"
import script from "./BusinessNatrue.vue?vue&type=script&lang=js"
export * from "./BusinessNatrue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f282e8",
  null
  
)

export default component.exports